// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './style/common.scss'
import Cube from 'cube-ui'
import {Loading,InfiniteScroll,Image, Popover, Input, Select} from 'element-ui';
Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  return !(this.filterable || this.multiple || !isIE) && !this.visible
}
//滚动条插件
import vuescroll from 'vuescroll/dist/vuescroll.min'
// 引入图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 引入视频预览样式
import VueVideoPlayer from 'vue-video-player'
// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
// 使用组件
Vue.use(VueVideoPlayer)
Vue.use(Cube);
Vue.use(Loading);
Vue.use(InfiniteScroll);
Vue.use(vuescroll);
Vue.component("XImage", Image);
Vue.use(Popover);
Vue.use(Input);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
Vue.config.productionTip = false

// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from './plugins/touchEvent'
Vue.use(VueTouch)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js